// These are the sounds we currently allow users
// to choose from when setting up a new sesh or preset
export const soundKeys = [
  // Check-in and end sounds
  'Tones',
  'Tones End',
  'Handpan',
  'Handpan End',
  'Kalimba',
  'Kalimba End',
  'Xylophone',
  'Xylophone End',
  'Celesta',
  'Celesta End',
  'Drum',
  'Drum End',
  'Cascade',
  'Cascade End',
  'Bass Clap',
  'Bass Clap End',
  // Soundtracks
  // - Genres
  'Lofi Beats',
  'Calming Classical',
  'Dream House',
  'Country',
  'Acoustic Guitar',
  'Americana',
  'Cinematic',
  // Boosts audio
  'Albany',
  'One Deep Breath Albany',
  'Pause Albany',
  'Settle In Albany',
  'Seattle',
  'One Deep Breath Seattle',
  'Pause Seattle',
  'Settle In Seattle',
  // Misc SFX
  'Correct',
  'Incorrect',
]

export const availableSoundOptions = [
  // currently available check-in sounds
  {
    checkInSound: 'Tones',
    endSound: 'Tones End',
    isCheckInSound: true,
    isAvailableCheckInSound: true,
    availableForSyncedSessions: true,
  },
  {
    checkInSound: 'Handpan',
    endSound: 'Handpan End',
    isCheckInSound: true,
    isAvailableCheckInSound: true,
    availableForSyncedSessions: true,
  },
  {
    checkInSound: 'Kalimba',
    endSound: 'Kalimba End',
    isCheckInSound: true,
    isAvailableCheckInSound: true,
    availableForSyncedSessions: true,
  },
  {
    checkInSound: 'Xylophone',
    endSound: 'Xylophone End',
    isCheckInSound: true,
    isAvailableCheckInSound: true,
    availableForSyncedSessions: true,
  },
  {
    checkInSound: 'Celesta',
    endSound: 'Celesta End',
    isCheckInSound: true,
    isAvailableCheckInSound: true,
    availableForSyncedSessions: false,
  },
  {
    checkInSound: 'Drum',
    endSound: 'Drum End',
    isCheckInSound: true,
    isAvailableCheckInSound: true,
    availableForSyncedSessions: false,
  },
  {
    checkInSound: 'Cascade',
    endSound: 'Cascade End',
    isCheckInSound: true,
    isAvailableCheckInSound: true,
    availableForSyncedSessions: false,
  },
  {
    checkInSound: 'Bass Clap',
    endSound: 'Bass Clap End',
    isCheckInSound: true,
    isAvailableCheckInSound: true,
    availableForSyncedSessions: true,
  },

  // Note. to add new soundtracks, we need to update 6 things:
  //  1. Create new folder and add actual soundtrack file to new folder AWS S3
  //  2. Create playlist-info.json for new soundtrack and add to the S3 folder
  //  3. Add preview sound file to app bundle.
  //  4. Add cover art file to app bundle.
  //  5. Add audio file key to soundKeys array at the top of this file
  //  6. Add object below
  //  ...
  //  If you are simply adding tracks to an existing playlist,
  //  you only need to add the track to AWS and update respective playlist-info.json

  // Genres
  {
    soundtrack: 'Lofi Beats',
    isCheckInSound: false,
    isSoundtrack: true,
    category: 'Genres',
  },
  {
    soundtrack: 'Calming Classical',
    isCheckInSound: false,
    isSoundtrack: true,
    category: 'Genres',
  },
  {
    soundtrack: 'Dream House',
    isCheckInSound: false,
    isSoundtrack: true,
    category: 'Genres',
    popular: true,
  },
  {
    soundtrack: 'Country',
    isCheckInSound: false,
    isSoundtrack: true,
    category: 'Genres',
    popular: true,
  },
  {
    soundtrack: 'Acoustic Guitar',
    isCheckInSound: false,
    isSoundtrack: true,
    category: 'Genres',
  },
  {
    soundtrack: 'Americana',
    isCheckInSound: false,
    isSoundtrack: true,
    category: 'Genres',
  },
  {
    soundtrack: 'Cinematic',
    isCheckInSound: false,
    isSoundtrack: true,
    category: 'Genres',
  },
]

// Note: to add a new category, simply add the category name to this array,
//  then update the category field in the relevant objects above

export const soundtrackCategories = [
  'Genres',
]

// Additional sounds that we still support for existing
// presets, but no longer give users the option to choose
export const legacySoundOptions = []
